import {
  FormatAlignCenter as FormatAlignCenterIcon,
  FormatAlignLeft as FormatAlignLeftIcon,
  FormatAlignRight as FormatAlignRightIcon,
} from '@mui/icons-material';
import { Box } from '@mui/material';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { isString } from 'lodash';
import React from 'react';
import { TextAlignmentEnum } from 'src/interfaces';

import { WidgetsCommonProps } from '../widget.interface';
import { InputLabel, ToggleSButtons } from './TextAlignButtonWidget.styled';

export const TextAlignButtonsWidget = React.forwardRef(
  (props: WidgetsCommonProps, ref) => {
    const handleAlignment = (
      event: React.MouseEvent<HTMLElement>,
      newAlignment: string | null,
    ) => {
      if (newAlignment) props.onChange(newAlignment);
    };

    return (
      <>
        <InputLabel>{props.label}</InputLabel>
        <Box ref={ref}>
          <ToggleButtonGroup
            value={props.value}
            exclusive
            onChange={handleAlignment}
            aria-label={isString(props.label) ? props.label : ''}>
            <ToggleSButtons
              value={TextAlignmentEnum.LEFT}
              aria-label="left aligned">
              <FormatAlignLeftIcon />
            </ToggleSButtons>
            <ToggleSButtons
              value={TextAlignmentEnum.CENTER}
              aria-label="centered">
              <FormatAlignCenterIcon />
            </ToggleSButtons>
            <ToggleSButtons
              value={TextAlignmentEnum.RIGHT}
              aria-label="right aligned">
              <FormatAlignRightIcon />
            </ToggleSButtons>
          </ToggleButtonGroup>
        </Box>
      </>
    );
  },
);
